import { UrlParser } from "@authory-packages/core";
import { V3Button } from "../../Button";
import { ModalIconSegment, V3ModalIconSegmentVariant } from "../../ReusableStyledComponents/ModalIconSegment";
import { RightAlignPanel } from "../../ReusableStyledComponents/RightAlignPanel";
import { V3CaptionGrey48 } from "../../ReusableStyledComponents/V3CaptionGrey48";
import { VerticalSpacing } from "../../VerticalSpacing";
import { RoundedBoxCTA } from "../SharedComponents/RoundedBoxCTA";
import { V3ButtonColor } from "../../Button/V3Button.types";

interface AddSourceUnsupportedProps {
    url: string;
    onGoBackHandler: () => void;
    onGoToAddManual: () => void;
}

export const AddSourceUnsupported = ({ url, onGoBackHandler, onGoToAddManual }: AddSourceUnsupportedProps) => {
    let domain = "";

    try {
        domain = UrlParser.extractDomain(url) || "";
    } catch {}

    return (
        <>
            <ModalIconSegment variant={V3ModalIconSegmentVariant.error} />
            <VerticalSpacing bottom={24}>
                <V3CaptionGrey48>
                    Authory currently can't automatically find all your articles from <strong>{domain}</strong>.
                </V3CaptionGrey48>
            </VerticalSpacing>
            <VerticalSpacing bottom={8}>
                <V3CaptionGrey48>
                    <strong>Here is what you can do:</strong>
                </V3CaptionGrey48>
            </VerticalSpacing>
            <RoundedBoxCTA text="Import content item by pasting its URL" onClick={onGoToAddManual} />
            <VerticalSpacing top={24}>
                <RightAlignPanel>
                    <V3Button text="Back" autoWidth color={V3ButtonColor.secondary} onClick={onGoBackHandler} />
                </RightAlignPanel>
            </VerticalSpacing>
        </>
    );
};
